import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllOvertime = createAsyncThunk('overtime/getAllOvertime', async (_, thunkAPI) => {
  try {
    const res = await axiosInstance.get(`/admin/overtimes`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getDetailOvertime = createAsyncThunk('overtime/getDetailOvertime', async (id, thunkAPI) => {
  try {
    const res = await axiosInstance.get(`/admin/overtimes/${id}`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createOvertime = createAsyncThunk('overtime/createOvertime', async (payload, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`/admin/overtimes`, payload);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateOvertime = createAsyncThunk('overtime/updateOvertime', async ({ id, payload }, thunkAPI) => {
  try {
    const res = await axiosInstance.put(`/admin/overtimes/${id}`, payload);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
export const deleteOvertime = createAsyncThunk('overtime/deleteOvertime', async (id, thunkAPI) => {
  try {
    const res = await axiosInstance.delete(`/admin/overtimes/${id}`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getAllOvertimeRules = createAsyncThunk('overtime/getAllOvertimeRules', async (_, thunkAPI) => {
  try {
    const res = await axiosInstance.get(`/admin/overtime-rules`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getDetailOvertimeRules = createAsyncThunk('overtime/getDetailOvertimeRules', async (id, thunkAPI) => {
  try {
    const res = await axiosInstance.get(`/admin/overtime-rules/${id}`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createOvertimeRules = createAsyncThunk('overtime/createOvertimeRules', async (payload, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`/admin/overtime-rules`, payload);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateOvertimeRules = createAsyncThunk(
  'overtime/updateOvertimeRules',
  async ({ id, payload }, thunkAPI) => {
    try {
      const res = await axiosInstance.put(`/admin/overtime-rules/${id}`, payload);

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
export const deleteOvertimeRules = createAsyncThunk('overtime/deleteOvertime', async (id, thunkAPI) => {
  try {
    const res = await axiosInstance.delete(`/admin/overtime-rules/${id}`);

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
